<div class="bcg p-4 ">
    <div class="row my-3">
        <div class="col-lg-7 col-sm-7 col-md-7">
            <p class="nav_link_cat ms-1  flex_row">
                <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Wallet</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Add New State Wallet</span>
            </p>
        </div>
    </div>

    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Add New Wallet</h5>
                    <p class="card-text text_p ">Add new state wallet balance here!</p>
                </div>
            </div>
        </div>
    </div>
    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="row mt-2 form_inputFields">
                    <div class="col-11 m-2">
                        <h5 class="title_five">Wallet Details</h5>
                        <form [formGroup]="addWalletForm">
                            <div formArrayName="addNewWalletDetails">
                                <section *ngFor="let details of walletDetailsArray().controls; let i=index"
                                    [formGroupName]="i">
                                    <div class="form_outline_sty">
                                        <div class="row">
                                            <div class="col-lg-4 col-sm-4 col-md-4">
                                                <span class="form_field">Select State</span><span
                                                    class="color_red">*</span>
                                                <div class="overlay">
                                                    <app-dropdown class="custom-dropdown text-left"
                                                        placeholder='Select State' [options]="states"
                                                        formControlName="state" optionValue="id" (onChange)="getStampType($event, i)"
                                                        optionLabel="state_name"></app-dropdown>
                                                </div>
                                                <span class="p-error" style="font-size: 0.5rem;"
                                                    *ngIf="submitted && walletDetailsArray().at(i).get('state')?.hasError('required')">*Select
                                                    state </span>
                                            </div>
                                            <div class="col-lg-4 col-sm-4 col-md-4">
                                                <span class="form_field">Denomination</span><span
                                                    class="color_red">*</span>
                                                <input type="number" class="form-control edit_input"
                                                    formControlName="denomination" placeholder="Enter Denomination"
                                                    pInputText (keypress)="numberOnly($event)">
                                                <span class="p-error" style="font-size: 0.5rem;"
                                                    *ngIf="submitted && walletDetailsArray().at(i).get('denomination')?.hasError('required')">*Enter
                                                    denomination </span>
                                            </div>

                                            <div *ngIf="i != 0" style="padding-top: 15px;" class="col-lg-1 col-sm-1 col-md-1 remove_btn">
                                                <button pButton pRipple type="button" icon="pi pi-trash"
                                                  (click)="removeDetails(i)" class="p-button-sm"></button>
                                              </div>

                                        </div>
                                        <div class="row mt-2">


                                            <div class="col-lg-4 col-sm-4 col-md-4">
                                                <span class="form_field">Select Stamp Type</span><span
                                                    class="color_red">*</span>
                                                <div class="overlay">
                                                    <!-- <p-select placeholder="Select Stamp Type"
                                                        class="custom-dropdown text-left" [options]="stampTypes"
                                                        optionValue="value" optionLabel="name"
                                                        formControlName="stampType"></p-select> -->

                                                    <app-dropdown [options]="typeData[i]" class="custom-dropdown"
                                                        placeholder="Select Stamp type" [autoDisplayFirst]="false"
                                                        optionLabel="name" optionValue="code"
                                                        formControlName="stampType"></app-dropdown>
                                                </div>
                                                <span class="p-error" style="font-size: 0.5rem;"
                                                    *ngIf="submitted && walletDetailsArray().at(i).get('stampType')?.hasError('required')">*Select
                                                    stamp type
                                                </span>
                                            </div>

                                            <div class="col-lg-4 col-sm-4 col-md-4">
                                                <span class="form_field">Amount</span><span class="color_red">*</span>
                                                <input class="form-control edit_input" formControlName="amount"
                                                    placeholder="Enter Amount" pInputText type="number"
                                                    (keypress)="numberOnly($event)">
                                                <span class="p-error" style="font-size: 0.5rem;"
                                                    *ngIf="submitted && walletDetailsArray().at(i).get('amount')?.hasError('required')">*Enter
                                                    amount </span>
                                            </div>

                                        </div>
                                    </div>

                                </section>

                            </div>
                            <div class="custom_button me-2 mt-3" style="margin-left: 7px;">
                                <p-button icon="pi pi-plus" label="Add New" (click)="addnewWalletDetail()"
                                    styleClass="p-button-sm-outline"></p-button>
                            </div>
                        </form>


                    </div>
                    <div class=" text-right custom_button me-2 mt-3" style="margin-left: 7px;">
                        <p-button label="Back" [routerLink]="['/doqfy/wallet/amount-balance']"
                            styleClass="p-button-sm"></p-button>
                        <p-button class="ms-2" label="Save" (click)="saveDetails()"
                            styleClass="p-button-sm-outline"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="toast_display_layer">
    <p-toast></p-toast>
</div>